import { getUnitsForQuantity } from '@oliasoft-open-source/units';
import { ReactUINodes } from 'common/enums/common.js';
import { EntityType } from 'common/enums/entity-enums.js';
import { IObject } from 'common/interfaces/hierarchy-entities.js';
import { ICommonTable } from 'common/interfaces/objects-interfaces.js';
import { isArray } from 'es-toolkit/compat';
import {
  getHeadersFromEntityType,
  getParametersFromEntityType,
  getQuantitiesFromEntityType,
  getSelectNodesFromEntityType,
  getTooltipsFromEntityType,
  getUnitsFromEntityType,
  getVectorHeadersFromEntityType,
  getVectorParametersFromEntityType,
  getVectorParamMap,
} from './utils.js';

export const getData = (dataObject: IObject, unitTemplate={}, isVectorTable = false, visibleColumns: string[] = [], renderMath: ((value: string) => React.ReactNode) | null = null): ICommonTable => {
  const parameters = isVectorTable ? getVectorParametersFromEntityType(dataObject.type as EntityType, visibleColumns) : getParametersFromEntityType(dataObject.type as EntityType, visibleColumns);
  const headers = isVectorTable ? getVectorHeadersFromEntityType(dataObject.type as EntityType, visibleColumns) : getHeadersFromEntityType(dataObject.type as EntityType, visibleColumns);
  const quantities = getQuantitiesFromEntityType(dataObject.type as EntityType, visibleColumns);
  const tooltips = getTooltipsFromEntityType(dataObject.type as EntityType, visibleColumns);
  const vectorParamMap = getVectorParamMap(dataObject.type as EntityType | undefined);
  const getValue = (row: { [key: string]: string | number }, param: string) => {
    if(!row) return '';
    if (isVectorTable && vectorParamMap && Object.keys(vectorParamMap).includes(param)) {
      const vectorContent = vectorParamMap[param].map(vectorParam => `(${row[vectorParam] || ''})`).join(', ');
      const mathString = '`('.concat(vectorContent).concat(')`');
      return (
        renderMath ? renderMath!(mathString) : mathString
      );
    }
    // Todo function once more then one item has options
    if (dataObject.type === EntityType.SurveyProgram) {
      const options = getSelectNodesFromEntityType(dataObject.type as EntityType, visibleColumns);
      if (options[param] === ReactUINodes.Select) {
        return {
          value: row[param],
          type: options[param],
          name: param,
        };
      }
      return row[param];
    }
    return row[param];
  };

  const getRows = (row: { [key: string]: string | number }) => {
    return parameters.map(param => getValue(row, param));
  };

  if (dataObject.type && Object.values(EntityType).includes(dataObject.type as EntityType)) {
    const rows = isArray(dataObject.data) ? dataObject.data.filter((_i, index) => index !== 0).map(getRows) : [getRows(dataObject.data)];
    const units = getUnitsFromEntityType(dataObject.type as EntityType, visibleColumns, unitTemplate);
    const pastedUnitsRow: Record<string, string> = dataObject?.data?.[0] ?? {};
    const holder: string[] = [];
    if (Object.keys(pastedUnitsRow).length) {
      parameters.forEach((param, index) => {
        const pastedUnit = pastedUnitsRow[param];
        const altUnits = getUnitsForQuantity(quantities[index]);
        // @ts-ignore
        holder.push(altUnits?.includes(pastedUnit) ? pastedUnit : undefined);
      });
    }

    const unitsRow = holder?.length ? [...holder] : units;
    return {
      headers,
      units: unitsRow,
      rows: rows as (string | number)[][],
      tooltips,
      quantities,
    };
  }
  return {
    headers: [],
    units: [],
    rows: [],
    tooltips: [],
    quantities: [],
  };
};
